import { render } from "./Certification_Left.vue?vue&type=template&id=2ce0780c"
import script from "./Certification_Left.vue?vue&type=script&lang=js"
export * from "./Certification_Left.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__